/*-----------------------------------------------------------------------------/
/ Custom Theme JS
/-----------------------------------------------------------------------------*/

// Insert any custom theme js here...

const price = document.getElementsByClassName('lb-upsell-money-2');

$(function(){

    $('.cart-item-final-line-price').append("(税抜)");
    $('.cart-item-original-line-price').append("(税抜)");


    $("#_ngc_stock_notice_btn").text("再入荷通知");
    $('.ngc__modal__companyName').hide();
	
    var Filter = []
    for (let i = 1; i < 50; i++) {
      Filter[i] = $('#Filter-詳細な絞り込み-'+i).parent().text();
      if (Filter[i].indexOf("Appify:DisableSoldOutUI") >= 0) {
          $('#Filter-詳細な絞り込み-'+i).parent().hide();
      }
      if (Filter[i].indexOf("Appify:Restock") >= 0) {
          $('#Filter-詳細な絞り込み-'+i).parent().hide();
      }
      if (Filter[i].indexOf("no-restock") >= 0) {
          $('#Filter-詳細な絞り込み-'+i).parent().hide();
      }
    }
  
});

// 期間表示設定はここから　【予約】
document.addEventListener("DOMContentLoaded", function () {

    ///***設定値*********************************************

    //設定のオンオフ
    var check_flg = 0 //設定オン「1」設定オフ「0」

    //制御したいセクションのID
    var section_id = "shopify-section-template--17382781878407__section_collection_ghwcnr";

    //表示期間の設定 ※必ず「06」頭の0をとらない！！！！
    var start_day = "2025-09-12";
    var start_time = "00:00";
    var end_day = "2025-09-12";
    var end_time = "18:00";

    ///***設定値*********************************************

    if(check_flg == 1){
        //セクションの取得
        const section = document.getElementById(section_id);

        // 表示期間の設定
        const startDate = new Date(start_day+"T"+start_time+":00+09:00");
        const endDate = new Date(end_day+"T"+end_time+":00+09:00");
        const now = new Date();

        if (now >= startDate && now <= endDate) {
            section.style.display = "block"; // 表示
        } else {
            section.style.display = "none"; // 非表示
        }
    }

});
// 期間表示設定はここまで





// 期間表示設定はここから　【抽選】
document.addEventListener("DOMContentLoaded", function () {

    ///***設定値*********************************************

    //設定のオンオフ
    var check_flg = 1 //設定オン「1」設定オフ「0」

    //制御したいセクションのID
    var section_id = "shopify-section-template--17382781878407__section_collection_RYVUkq";

    //表示期間の設定 ※必ず「06」頭の0をとらない！！！！
    var start_day = "2025-10-30";
    var start_time = "09:00";
    var end_day = "2025-11-04";
    var end_time = "10:00";

    ///***設定値*********************************************

    if(check_flg == 1){
        //セクションの取得
        const section = document.getElementById(section_id);

        // 表示期間の設定
        const startDate = new Date(start_day+"T"+start_time+":00+09:00");
        const endDate = new Date(end_day+"T"+end_time+":00+09:00");
        const now = new Date();

        if (now >= startDate && now <= endDate) {
            section.style.display = "block"; // 表示
        } else {
            section.style.display = "none"; // 非表示
        }
    }

});
// 期間表示設定はここまで


